
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-label":"event-svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('event')]),_c('circle',{attrs:{"cx":"8","cy":"6","r":"3","stroke":"#63756B","stroke-width":"2"}}),_c('path',{attrs:{"d":"M11.5 20.333H1C1.26 17.89 3.022 13 8 13s7 5 7 8","stroke":"#63756B","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"17.5","cy":"6.5","r":"2.5","stroke":"#63756B","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.501 14c-.843 0-1.516.203-2.06.512l-.988-1.74c.851-.483 1.866-.772 3.048-.772 2.325 0 3.982 1.133 5.025 2.568 1.019 1.4 1.475 3.11 1.475 4.432v1h-6v-2h3.89a5.962 5.962 0 00-.982-2.256C20.179 14.742 19.087 14 17.5 14z","fill":"#63756B"}})])
          )
        }
      }
    